import {Component, OnInit} from '@angular/core';
import {PrivateAreaService} from '../../services/private-area.service';
import {faArrowLeft} from '@fortawesome/free-solid-svg-icons/faArrowLeft';
import {faChevronLeft} from '@fortawesome/free-solid-svg-icons/faChevronLeft';

import {ActivatedRoute, Router} from '@angular/router';
import {ContractDetails} from '../../models/interface-contract-details';

declare var require: any;
const FileSaver = require('file-saver');

@Component({
    selector: 'app-contract-details',
    templateUrl: './contract-details.component.html',
    styleUrls: ['./contract-details.component.scss']
})
export class ContractDetailsComponent implements OnInit {
    contractNumber: string;
    textMessage: string;
    textMessageError: string;
    modalId: string;
    showLoader = false;
    contractData: ContractDetails;
    faArrowLeft: any;
    limitRenovation: boolean;
    limitRenovationWarning: string;
    faChevronLeft:any;

    constructor(public privateAreaService: PrivateAreaService, private activatedRoute: ActivatedRoute, private router: Router) {
        this.modalId = 'request-contract';
        this.faArrowLeft = faArrowLeft;
        this.limitRenovation = false;
        this.faChevronLeft=faChevronLeft;
    }

    ngOnInit(): void {
        this.showLoader = true;
        this.activatedRoute.url.subscribe(url => {
            this.contractNumber = url[1].path;
        });
        this.privateAreaService.GetContractData(this.contractNumber).subscribe(resp => {
            this.showLoader = false;
            this.contractData = resp;
            if(this.contractData['renovacionesExcedidas']) {
                this.limitRenovationWarning = this.contractData['renovacionesExcedidas'];
                this.limitRenovation = true;
            }
            //console.log(this.contractData);
        }, error => {
            this.showLoader = false;
            this.textMessageError = 'Algo ha fallado; inténtalo más tarde.';
        });
    }

    requestContractRenewal() {
        this.showLoader = true;
        this.privateAreaService.requestContractRenewal(this.contractNumber).subscribe(res => {
            if (res.precioRecompraRenovacion > 0 && res.sequence) {
                sessionStorage.setItem('dataRenovation', JSON.stringify(res));
                this.router.navigateByUrl('resumen-de-renovacion');
            } else {
                this.showLoader = false;
                this.textMessage = 'Lo sentimos, el contrato no es renovable';
                document.getElementById(this.modalId).classList.remove('d-none');
            }
        }, error => {
            if (error.status === 400){
                this.showLoader = false;
                this.textMessage = 'Lo sentimos, el contrato pertenece a ningún cliente';
                document.getElementById(this.modalId).classList.remove('d-none');
            } else {
                this.showLoader = false;
                this.textMessage = 'Algo ha fallado; inténtalo más tarde.';
                document.getElementById(this.modalId).classList.remove('d-none');
            }
        });
    }

    downloadContractPdf(codContract, contractNumbero) {
        this.showLoader = true;
        this.privateAreaService.getContract(codContract).subscribe(res => {
            FileSaver.saveAs(res, `Contrato ${contractNumbero}`);
            this.showLoader = false;
        }, error => {
            if (error.status === 400) {
                this.showLoader = false;
                this.textMessage = 'Lo sentimos, el código de facturación no es válido';
                document.getElementById(this.modalId).classList.remove('d-none');
            } else {
                this.showLoader = false;
                this.textMessage = 'Algo ha fallado; inténtalo más tarde.';
                document.getElementById(this.modalId).classList.remove('d-none');
            }
        });

    }
}
